import { BindAll } from 'lodash-decorators';
import { EnumAPI } from '../../apis';
import { AjaxBasics } from '../../libraries';

@BindAll()
export class LiveController {
  /** 是否需要登录 */
  async getIsNeedLogin(body) {
    return await AjaxBasics.request({
      ...EnumAPI.live_mudu_isTouristVisits,
      body,
    });
  }

  /** 校验是否允许访问 */
  async userAuthCheck(body) {
    return await AjaxBasics.request({
      ...EnumAPI.live_mudu_userAuthCheck,
      body,
    });
  }

  /** 记录访问日志 */
  async onLogSave(body) {
    return await AjaxBasics.request({
      ...EnumAPI.live_mudu_log_save,
      body,
    });
  }
}
